import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** START ADD BUSINESS FUND DETAILS ******************/
export const businessfundDetailsAdd = (addData: any) => {
	const data = {
		AddBusinessFundDetailsToken: addData,
	};
	const url = `${API_URL}addBusinessFundDetails`;
	return makeApiCall(url, data);
};
/*************** END ADD BUSINESS FUND DETAILS ******************/

/*************** START UPDATE BUSINESS FUND DETAILS ******************/
export const businessfundDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateBusinessFundDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessFundDetails`;
	return makeApiCall(url, data);
};
/*************** END UPDATE BUSINESS FUND DETAILS ******************/

/*************** START GET BUSINESS FUND LIST ******************/
export const businessfundListGet = (listData: any) => {
	const data = {
		GetBusinessFundListToken: listData,
	};
	const url = `${API_URL}getBusinessFundList`;
	return makeApiCall(url, data);
};
/*************** END GET BUSINESS FUND LIST ******************/

/*************** START FETCH BUSINESS FUND DETAILS ******************/
export const businessfundDetailsFetch = (fetchData: any) => {
	const data = {
		FetchBusinessFundDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchBusinessFundDetails`;
	return makeApiCall(url, data);
};
/*************** END FETCH BUSINESS FUND DETAILS ******************/

/*************** START DELETE BUSINESS FUND DETAILS ******************/
export const businessfundDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteBusinessFundDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessFundDetails`;
	return makeApiCall(url, data);
};
/*************** END DELETE BUSINESS FUND DETAILS ******************/

/*************** START GET ALL BUSINESS FUNDS ******************/
export const allbusinessfundFetch = (fetchAllBusinessfundData: any) => {
	const data = {
		AllBusinessfundListFetchToken: fetchAllBusinessfundData,
	};
	const url = `${API_URL}fetchAllBusinessfundList`;
	return makeApiCall(url, data);
};
/*************** END GET ALL BUSINESS FUNDS ******************/
